/**
 * Maps a browser filename to the vendor/requirement row it belongs to.
 *
 * Used during upload to highlight the correct FileRequirementsPanel row
 * before the backend responds with file-status data.
 */

const VENDOR_PATTERNS: [RegExp, string][] = [
  [/^VI_.*\.csv$/i, "tekion"],
  [/.*_Sales_Inventory\.csv$/i, "rapidrecon"],
  [/^InventoryReport.*\.xls/i, "homenet"],
  [/^Vehicles.*\.csv$/i, "stargard"],
  [/^View My Inventory.*\.csv$/i, "dealerconnect"],
  [/.*Inventory.*Summary.*\.xls/i, "dealerdaily_toyota"],
]

export function detectVendorFromFilename(filename: string): string {
  for (const [pattern, vendor] of VENDOR_PATTERNS) {
    if (pattern.test(filename)) return vendor
  }
  // AutoExact: filename always contains "autoexact" (usually "aex.autoexact.com" from the export URL).
  // Windows Chrome omits the .pdf extension when URL has query params.
  if (filename.toLowerCase().includes("autoexact")) {
    return "autoexact"
  }
  return "unknown"
}
